// extracted by css-extract-rspack-plugin
export default {"IconWrapper":"BannerNudgeCard-module__IconWrapper__cXfHh"};